import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group/main/button-group.view";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/button.view";
import { ModalNotification } from "@com.mgmtp.a12.widgets/widgets-core/lib/modal-notification/main/modal-notification.view";

import { RESOURCE_KEYS } from "../../../localization";
import { getViewHtmlId } from "../../focusHandling/sagas";

const MODAL_RESOURCE_KEYS = RESOURCE_KEYS.features.modals;

export function CustomLoeschenContainer(props: View) {
	const { activityId } = props;

	const descriptor = useSelector(ActivitySelectors.activityPropById(activityId, it => it.descriptor));

	const dispatch = useDispatch();
	const { localizer } = React.useContext(LocalizerContext);

	const onAbbrechenClick = React.useCallback(() => {
		dispatch(
			ActivityActions.cancel({
				activityId: activityId
			})
		);
	}, [dispatch, activityId]);

	const onLoeschenClick = React.useCallback(() => {
		const initiatingActivityId = descriptor?.overviewId;
		const instanceId = descriptor?.instance;

		if (!initiatingActivityId || !instanceId) {
			return;
		}

		dispatch(
			ActivityActions.cancel({
				activityId: activityId
			})
		);

		dispatch(
			ActivityActions.removeData({
				activityId: initiatingActivityId,
				instanceId
			})
		);
	}, [descriptor, dispatch, activityId]);

	return (
		<ModalNotification
			id={getViewHtmlId(activityId)}
			variant="warning"
			title={localizer({ key: MODAL_RESOURCE_KEYS.title.loeschenModal })}
			footer={
				<ButtonGroup alignment="right">
					<Button
						label={localizer({ key: MODAL_RESOURCE_KEYS.button.abbrechen })}
						secondary
						onClick={onAbbrechenClick}
					/>
					<Button
						label={localizer({ key: MODAL_RESOURCE_KEYS.button.loeschen })}
						destructive
						primary
						onClick={onLoeschenClick}
					/>
				</ButtonGroup>
			}
		>
			<p>{localizer({ key: MODAL_RESOURCE_KEYS.content.loeschenModal })}</p>
		</ModalNotification>
	);
}
